<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          RFQs &nbsp;
          <add-button link="/procurement-management/rfqs/create"></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">RFQs</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="Exportrfqs.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="rfqs_excel"
                :fields="excel_fields"
                worksheet="RFQs"
                name="RFQ.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Requisition</th>
                    <th>RFQ Number</th>
                    <th>RFD Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="rfqs.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr v-for="(rfq, at) in rfqs" :key="`rfq${at}`">
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>
                      {{
                        rfq.requisition ? rfq.requisition.requisition_no : ""
                      }}
                    </td>
                    <td>
                      {{ rfq.rfq_no }}
                    </td>
                    <td>
                      {{ rfq.rfd_date }}
                    </td>
                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/rfqs/${rfq.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(rfq.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "rfq",
  data() {
    return {
      rfqs: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      rfqs_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Requisition: "requisition",
        "RFQ No": "rfq_no",
        "RFD Date": "rfd_date",
      },
      Exportrfqs: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let rfqs = await axios.get(
        `/rfqs?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.rfqs = rfqs.data.data;
      this.count = rfqs.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let rfqs = await axios.get(`/rfqs?search=${this.searchData}`);
      this.rfqs = rfqs.data.data;
      this.count = rfqs.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "RFQ Data";
      this.rfqs_excel = [];
      let Exportrfqs = [];
      Exportrfqs = await axios.get(`/rfqs`);
      this.Exportrfqs = Exportrfqs.data.data;
      let sr_no = 1;
      this.Exportrfqs.forEach((rfq) => {
        this.rfqs_excel.push({
          sr_no: sr_no,
          requisition: rfq.requisition ? rfq.requisition.requisition_no : "",
          rfq_no: rfq.rfq_no ? rfq.rfq_no : "",
          rfd_date: rfq.rfd_date ? rfq.rfd_date : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=rfqs`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
